import React from "react";
import { SubmitButton, SelectForm } from "components";
import {
  featuredOptions,
} from "props/enum";

interface FormProps {
  loading: boolean;
  featured: string;
  handleChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
}

export const VideoFeaturedForm: React.FC<FormProps> = ({
  featured,
  handleChange,
  handleSubmit,
  loading,
}) => {
  return (
    <form>
      <h2 className="text-xl font-bold my-3">Update Video Featured</h2>
      <div className="pb-3">
        <SelectForm
          label="Video Featured"
          id="featured"
          name="featured"
          value={featured}
          option={featuredOptions.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
          onChange={handleChange}
        />
      </div>
      <SubmitButton loading={loading} onClick={handleSubmit} />
    </form>
  );
};
